import type { District, PropertyCategory, ListingType, PropertyStatus } from '../types/cms';

export const districtLabels: Record<District, string> = {
  all: '所有',
  tsuen_wan: '荃灣',
  kwai_chung: '葵涌',
  lai_chi_kok: '荔枝角',
  other: '其他',
};

export const categoryLabels: Record<PropertyCategory, string> = {
  office: '寫字樓',
  industrial: '工商 / 貨倉',
  shop: '地舖',
  car_park: '車位',
  other: '其他',
};

export const listingLabels: Record<ListingType, string> = {
  sale: '放售',
  rent: '放租',
  sale_or_rent: '租售均可',
};

export const statusLabels: Record<PropertyStatus, string> = {
  available: '可租售',
  rented: '已租',
  sold: '已售',
  exclusive: '獨家',
};

export const statusBadgeClasses: Record<PropertyStatus, string> = {
  available: 'bg-slate-500',
  rented: 'bg-green-600',
  sold: 'bg-red-600',
  exclusive: 'bg-blue-700',
};

export const formatPrice = (price: number, unit: string) => {
  if (unit.includes('月')) {
    return `$${price.toLocaleString()}${unit.replace('HKD', '')}`;
  }
  if (price >= 1000000) {
    return `$${(price / 1000000).toFixed(1)}M`;
  }
  return `$${price.toLocaleString()}`;
};

export const getWhatsAppUrl = (phone: string, message: string) => {
  const cleanPhone = phone.replace(/\D/g, '');
  return `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`;
};

export const getGoogleMapsUrl = (address: string) => {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
};

const SHARE_HOST =
  typeof import.meta.env !== 'undefined' && import.meta.env.VITE_SHARE_URL
    ? import.meta.env.VITE_SHARE_URL
    : 'https://marveland.hk';

export const getShareUrl = (propertyId: string) => `${SHARE_HOST}/share/properties/${propertyId}`;

